<!--
    我的课程-课程详情-主要内容组件
    功能：主要内容组件
    说明：版本3.0
-->
<template>
  <div class="detail-content">
    <div class="introduction">
      <div class="title">课程简介</div>
      <div class="cont">{{ detail.introduction }}</div>
    </div>
    <div class="detail">
      <div class="title"><span>课程详情</span><span
        class="more"
        @click="handlerMore">{{ !isMore?'展开详情':'收起详情' }} <i
          :class="isMore&&'set-up'"
          class="icon el-icon-arrow-down"/></span></div>
      <div
        :class="!isMore&&'text-over'"
        class="cont"
        v-html="detail.detail"/>
    </div>
    <div
      v-if="isCascader"
      class="form">
      <span>分类：</span>
      <el-cascader
        v-model="cascaderVal"
        :options="getCascader"
        :props="{
          value: 'id',
          label: 'name',
          checkStrictly: true,
          children: 'recursive_children',
        }"
        clearable
        @change="handlerCascader"
      />
    </div>
    <div class="list">
      <goods-item
        v-for="(item,index) in goodsList"
        ref="goods"
        :key="index"
        :item="{...item,index:index}"
        @handler-item="handlerItem"/>
    </div>
  </div>
</template>
<script>
import goodsItem from './goods-item.vue';

export default {
  name: 'DetailContent',
  components: {
    goodsItem,
  },
  props: {
    detail: Object,
    goodsList: Array,
    getCascader: Array,
    isCascader: Boolean,
  },
  data() {
    return {
      info: {},
      isMore: false,
      cascaderVal: '',
      hourOptions: [
        {
          value: 0,
          label: '幼儿班',
        },
        {
          value: 1,
          label: '一年级',
        },
      ],
      list: [],
    };
  },
  methods: {
    handlerMore() {
      this.isMore = !this.isMore;
    },
    handlerCascader(val) {
      const searchVal = val[val.length - 1];
      this.$emit('search', searchVal);
    },
    handlerItem(val) {
      this.goodsList.forEach((item, index) => {
        if (val.id !== item.id) {
          this.$refs.goods[index].clerActive();
        } else {
          this.$refs.goods[index].toggleActive();
        }
      });
      const filterArr = this.$refs.goods.filter(item => item.isActive === true);
      if (filterArr.length > 0) {
        this.$emit('setCheckItem', filterArr[0].item);
      } else {
        this.$emit('setCheckItem', {});
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.detail-content{
  margin-top: 20px;
  text-align: left;
  .title{
    margin-top: 10px;
    color: #303133;
    font-size: 16px;
    font-weight: 600;
    line-height: 30px;
  }
  .cont{
    color: #606266;
    font-size: 14px;
    line-height: 30px;
  }
  .detail{
     .title{
       display: flex;
       justify-content: space-between;
       .more{
         cursor: pointer;
         font-weight: 500;
         font-size: 14px;
         color: #FF7838;
         .icon{
           transition: all ease .3s;
           &.set-up{
             transform: rotate(180deg);
           }
         }
       }
     }
     .cont{
      transition: all ease .3s;
     }
    .text-over{
      overflow: hidden;
      text-overflow: ellipsis;
      display:-webkit-box;
      -webkit-box-orient:vertical;
      -webkit-line-clamp:3;
    }
  }
  .form{
    margin-top: 20px;
  }
  .list{
    display: flex;
    flex-wrap: wrap;
    margin-top: 10px;
    margin-left: -10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/MyCourse/packageDetail/components/detailContent.vue